import React, { useEffect, useState } from "react";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import moment from "moment";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import viewTable from "../../../../../assets/icons/viewTable.svg";
import addREC from "../../../../../assets/icons/addREC.svg";
import editIcons from "../../../../../assets/icons/editIcons.svg";
import deleteRedIcons from "../../../../../assets/icons/delete-red.svg";
import CompanyDashboardInitiativeDrawerAddDisposition from "./company-dashboard-initiative-drawer-add-disposition/company-dashboard-initiative-drawer-add-disposition";
import CompanyDashboardInitiativeDrawerViewDisposition from "./company-dashboard-initiative-drawer-view-disposition/company-dashboard-initiative-drawer-view-disposition";
import DeleteConfirmationPopup from "../../../../../common/components/delete-confirmation-popup/delete-confirmation-popup";
import { deleteDispositionByID } from "../../../../../api/disposition";
import "./company-dashboard-initiative-add-drawer-disposition.scss";
import { usePermissions } from "../../../../../common/hooks/usePermissions";
import MODULES from "../../../../../constants/modules";
import ActionsIcon from "../../../../../assets/icons/actionsIcon.svg";
import { Tooltip } from "@mui/material";

const CompanyDashboardAddInitiativeDisposition: any = (props: any) => {
  const {
    initiativeId,
    initiativeAPIData,
    fetchInitiativeById,
    setAlertType,
    setAlertOpen,
    setLoading,
    setAlertMessage,
    initiativeDataPermissions,
  } = props;
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [isOpenAddPopup, setIsOpenAddPopup] = useState(false);
  const [addPopupTitle, setAddPopupTitle] = useState("");
  const [isOpenViewPopup, setIsOpenViewPopup] = useState(false);
  const [isDeletePopupOpen, setDeletePopupOpen] = useState(false);
  const [deletePopupId, setDeletePopupId] = useState<number | null>(null);
  const [editData, setEditData] = useState<any>(null);
  const [dispositionData, setDispositionData] = useState([]);
  const { canRead, canWrite, canEdit, canDelete } = usePermissions(
    MODULES.INITIATIVES,
  );

  useEffect(() => {
    if (initiativeAPIData) {
      setDispositionData(
        initiativeAPIData?.latestDisposition?.map((item: any) => ({
          id: item.dispositionId,
          asOf: item.date,
          openedBy: item.reportedBy,
          description: item.description,
          percentageComplete: item.percentageComplete,
        })) || [],
      );
    }
  }, [initiativeAPIData]);

  const handleOpenAddPopup = () => {
    setIsOpenAddPopup(true);
    setAddPopupTitle("Add Disposition");
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleCloseAddPopup = () => {
    setIsOpenAddPopup(false);
    setEditData(null);
    setAddPopupTitle("");
  };
  const handleOpenViewPopup = () => {
    setIsOpenViewPopup(true);
  };
  const handleCloseViewPopup = () => {
    setIsOpenViewPopup(false);
  };

  const handleOpenEditPopup = (data: any) => {
    setIsOpenAddPopup(true);
    setEditData(data);
    setAddPopupTitle("Edit Disposition");
    handleClose();
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleOpenDeletePopup = (data: any) => {
    setDeletePopupOpen(!isDeletePopupOpen);
    setIsOpenViewPopup(false);
    setDeletePopupId(data?.id);
    handleClose();
  };

  const deleteDisposition = async () => {
    setLoading(true);
    try {
      await deleteDispositionByID(deletePopupId);
      fetchInitiativeById();
      setAlertMessage("Disposition deleted successfully");
      setAlertType("success");
      setAlertOpen(true);
      setDeletePopupOpen(false);
      setLoading(false);
      setDeletePopupId(null);
    } catch {
      setAlertMessage("Failed to delete disposition");
      setAlertType("error");
      setAlertOpen(true);
      setDeletePopupOpen(false);
      setDeletePopupId(null);
      setLoading(false);
    }
  };

  const options = [
    ...(canEdit && canDelete && initiativeDataPermissions
      ? [{ label: "Edit", onClick: handleOpenEditPopup, icon: editIcons }]
      : []),
    ...(canDelete && initiativeDataPermissions
      ? [
          {
            label: <div style={{ marginLeft: "5px" }}>Delete</div>,
            onClick: handleOpenDeletePopup,
            icon: deleteRedIcons,
            altText: "Delete",
          },
        ]
      : []),
  ];
  const ITEM_HEIGHT = 48;

  if (!canRead) {
    return <div>No access to this section.</div>;
  }

  return (
    <>
      {anchorEl && <div className="menu-overlay"></div>}

      <div className="company-dashboard-initiative-drawer-disposition">
        <div className="company-dashboard-initiative-drawer-disposition-header">
          <div>Latest Disposition</div>
          <div className="company-dashboard-initiative-drawer-disposition-header-actions">
            {dispositionData.length > 1 && (
              <button
                style={{
                  border: "none",
                  background: "none",
                  cursor: "pointer",
                }}
                onClick={handleOpenViewPopup}
              >
                <img src={viewTable} style={{ cursor: "pointer" }} alt="view" />
              </button>
            )}

            {canWrite &&
              initiativeDataPermissions &&
              (initiativeId ? (
                <button
                  style={{
                    border: "none",
                    background: "none",
                    padding: 0,
                  }}
                  onClick={handleOpenAddPopup}
                >
                  <img
                    src={addREC}
                    alt="add"
                    className="company-dashboard-initiative-drawer-disposition-header-actions-add"
                    style={{
                      cursor: "pointer",
                      opacity: 1,
                    }}
                  />
                </button>
              ) : (
                <Tooltip title="Please create an Initiative first to create Disposition">
                  <span
                    style={{
                      display: "inline-block",
                      pointerEvents: "auto", // ensure span receives hover
                    }}
                  >
                    <img
                      src={addREC}
                      alt="add"
                      className="company-dashboard-initiative-drawer-disposition-header-actions-add"
                      style={{
                        cursor: "not-allowed",
                        opacity: 0.5,
                        pointerEvents: "none", // disable click but allow parent span hover
                      }}
                    />
                  </span>
                </Tooltip>
              ))}
          </div>
        </div>
        {dispositionData?.length
          ? [dispositionData?.[0]]?.map((item: any) => (
              <OverlayScrollbarsComponent
                key={item.id}
                className="company-dashboard-initiative-drawer-disposition-content"
                options={{
                  scrollbars: {
                    theme: "os-theme-dark",
                    autoHide: "scroll",
                    autoHideDelay: 400,
                  },
                }}
              >
                <div className="company-dashboard-initiative-drawer-disposition-content-header-action">
                  <div
                    className="company-dashboard-initiative-drawer-disposition-content-header-action-text"
                    style={
                      !initiativeDataPermissions || !canWrite
                        ? { justifyContent: "flex-start", gap: "20%" }
                        : {}
                    }
                  >
                    <div className="company-dashboard-initiative-drawer-disposition-content-header-action-text-box">
                      As of: <br />
                      <span>{moment(item?.asOf).format("MM-DD-YYYY")}</span>
                    </div>
                    <div className="company-dashboard-initiative-drawer-disposition-content-header-action-text-box">
                      Reported By:
                      <br /> <span>{item?.openedBy}</span>
                    </div>
                    {initiativeDataPermissions && options.length > 0 && (
                      <div className="company-dashboard-initiative-drawer-disposition-content-header-action-button">
                        <IconButton aria-label="more" onClick={handleClick}>
                          <img
                            className="actions-icon"
                            src={ActionsIcon}
                            alt="Actions"
                          />
                        </IconButton>
                        <Menu
                          anchorEl={anchorEl}
                          open={open}
                          onClose={handleClose}
                          slotProps={{
                            paper: {
                              style: {
                                maxHeight: ITEM_HEIGHT * 4.5,
                                boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.12)",
                                borderRadius: 16,
                                padding: 0,
                              },
                              sx: {
                                "&.MuiPaper-root": {
                                  padding: "0px !important",
                                  width: "156px",
                                },
                              },
                            },
                            list: { "aria-labelledby": "long-button" },
                          }}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "right",
                          }}
                        >
                          {options.map((option) => (
                            <MenuItem
                              key={option?.altText}
                              onClick={() => option.onClick(item)}
                              sx={{ padding: "8px 16px !important" }}
                            >
                              <img src={option.icon} alt={option?.altText} />
                              {option.label}
                            </MenuItem>
                          ))}
                        </Menu>
                      </div>
                    )}
                  </div>
                </div>
                <div className="company-dashboard-initiative-drawer-disposition-content-main">
                  <div className="company-dashboard-initiative-drawer-disposition-content-main-text">
                    {item?.description || "-"}
                  </div>
                </div>
              </OverlayScrollbarsComponent>
            ))
          : ""}
        {isOpenAddPopup ? (
          <CompanyDashboardInitiativeDrawerAddDisposition
            isOpenAddPopup={isOpenAddPopup}
            onCancel={handleCloseAddPopup}
            title={addPopupTitle}
            dispositionData={dispositionData}
            setDispositionData={setDispositionData}
            setEditData={setEditData}
            editData={editData}
            initiativeId={initiativeId}
            fetchInitiativeById={fetchInitiativeById}
            setAlertType={setAlertType}
            setAlertOpen={setAlertOpen}
            setLoading={setLoading}
            setAlertMessage={setAlertMessage}
          />
        ) : null}

        <CompanyDashboardInitiativeDrawerViewDisposition
          isOpenViewPopup={isOpenViewPopup}
          onCancel={handleCloseViewPopup}
          dispositionData={dispositionData}
          options={options.filter((option: any) => option.altText === "Delete")}
          initiativeDataPermissions={initiativeDataPermissions}
        />
        {isDeletePopupOpen ? (
          <DeleteConfirmationPopup
            isOpen={true}
            onClose={() => {
              setDeletePopupOpen(!isDeletePopupOpen);
              setDeletePopupId(null);
            }}
            handleDelete={() => {
              deleteDisposition();
            }}
            deleteId={null}
          />
        ) : null}
      </div>
    </>
  );
};

export default CompanyDashboardAddInitiativeDisposition;
